export const Farben = Object.freeze({
	nettovermoegen: "#2A90EA",
	einnahmen: "#9FD356",
	ausgaben: "#B74F6F",
	liquidierung: "#0F4C81",
	kosten: "#C46F89",

	aktien: "#1293B8",
	anleihen: "#A7CECB",
	cash: "#7BAE7F",
	sonstiges: "#B59C92",

	zuVersteuerndesEinkommen: "#5B96C2",
	sozialpflichtigesEinkommen: "#FFBE98",
	steuerBetrag: "#075688",

	// Orange
	kapitalertraegeUnternehmen: "#F9AB55",
	steuerbetraegeUnternehmen: "#A65A1E",
})
